module.exports = __webpack_public_path__ + "static/media/WordsHavePower_p32.00b661d9.jpg";